import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

const BarChart = () => {
  const data = {
    labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    datasets: [
      {
        label: "Revenue collected Ksh",
        data: [10, 12, 24, 18, 29, 20, 23],
        backgroundColor: [
          "#E2E8EE", // Dark blue
          "#E2E8EE",
          "#E2E8EE",
          "#E2E8EE",
          "rgba(25,42,58,1)", // Gold
          "#E2E8EE",
          "#E2E8EE",
        ],
        borderRadius: 5,
        borderSkipped: false,
      },
    ],
  };

  const options = {
    onHover: (event, chartElement) => {
      if (chartElement.length) {
        const chart = chartElement[0].element.$context.chart;
        event.native.target.style.cursor = "pointer";
        const index = chartElement[0].index;
        chart.data.datasets.forEach((dataset) => {
          dataset.backgroundColor = dataset.data.map((data, j) =>
            j === index ? "rgba(25,42,58,1)" : "rgba(25,42,58, 0.2)",
          );
        });
        chart.update();
      } else {
        const chart = event.chart;
        event.native.target.style.cursor = "default";
        chart.data.datasets.forEach((dataset) => {
          //assign the original colors
          dataset.backgroundColor = [
            "#E2E8EE", // Dark blue
            "#E2E8EE",
            "#E2E8EE",
            "#E2E8EE",
            "rgba(25,42,58,1)", // Gold
            "#E2E8EE",
            "#E2E8EE",
          ];
        });
        chart.update();
      }
    },
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
      },
    },
    scales: {
      x: {
        display: true,
        border: {
          color: "transparent",
        },
        grid: {
          display: false,
        },
        barPercentage: 0.98, // Adjust the width of the bars
        categoryPercentage: 0.98, // Adjust the space between bars
      },
      y: {
        display: false,
        grid: {
          drawBorder: false,
          display: false,
          color: "#E2E8F0", // Light gray gridlines
        },
        ticks: {
          stepSize: 10,
          color: "#4A5568", // Dark gray tick color
        },
      },
    },
  };

  return (
    <div style={{ width: "100%" }}>
      <Bar data={data} options={options} />
    </div>
  );
};

export default BarChart;
